import styled from '@emotion/styled';
import { Button, Hyperlink } from 'react-magma-dom';

interface IFooter {
  color: string;
}

export const StyledFooter = styled.footer<IFooter>`
  left: 0;
  bottom: 0;

  width: 100%;
  height: 50px;
  padding: 15px 27px 15px 26px;
  object-fit: contain;
  background-color: ${({ color }) => color};
`;

export const StyledWrapper = styled.div`
  color: white;
  line-height: 1.67;
  letter-spacing: 0.16px;
  font-size: 12px;

  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;

export const StyledLeftSideWrapper = styled.div`
  display: flex;
`;

export const StyledFooterLink = styled(Hyperlink)`
  text-transform: uppercase;
  text-decoration: none !important;
  display: flex;
  color: #fff !important;
`;

export const StyledFooterButton = styled(Button)`
  min-width: 0px !important;
  letter-spacing: 0.16px !important;
  width: auto !important;
  height: auto !important;
  margin: 0 !important;
  padding: 0 !important;
  line-height: unset !important;
  font-size: 12px !important;
  display: flex;
  font-weight: 600 !important;
  border: none;
  border-radius: 0;
  background: none;
  color: #fff !important;
  &:active,
  :hover {
    background: none !important;
    color: #fff !important;
  }

  &:focus {
    background: none !important;
    outline: 2px dotted rgba(255, 255, 255, 0.7) !important;
    color: #fff !important;
  }
`;

export const StyledFooterLine = styled.div`
  margin: 0px 24px 0 24px;

  @media (max-width: 1023px) {
    margin: 0px 9px 0 9px;
  }

  @media (max-width: 768px) {
    margin: 0px 6px 0 2px;
  }

  border: solid 1px white;
  background-color: white;
  height: 17px;
`;

export const StyledUnderline = styled.span`
  text-decoration: underline;
`;
